import React from 'react';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import TransportTypeImage from './TransportTypeImage';
import { IOrderState, ITransportState, useAppState } from '../../states/app-state';
import styles from './TransportsCompact.module.scss'; // added by Bearer Web Developer
import { useThemeMode } from '../../states/contexts/theme'; // added by Bearer Web Developer
// useStyles removed by Bearer Web Developer

const TransportsCompact: React.FC<{ transport: ITransportState, selectedOrder: IOrderState }> = observer(({ transport, selectedOrder }) => {

    const isDisabled = transport.isDisabled;
    // added by Bearer Web Developer start
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    const appState = useAppState();
    const { order } = appState.selectedOrder!.payment;
    const realPrice = order?.selectedTransportOption?.price;
    const discountedPrice = order?.discount.value?.transport_receivable_price; // added by Bearer Web Developer
    const originalPrice = appState.selectedOrder?.transport?.value?.transport_original_price; // added by Bearer Web Developer
    const showRealPrice = !(discountedPrice && (Number(discountedPrice) > Number(originalPrice))); // added by Bearer Web Developer
    const madeOfTransport = selectedOrder.transportOptions.selectedOption!;
    const capitalizeFirstLetterMadeOfTransport = madeOfTransport?.slice(0, 1).toLocaleUpperCase() + madeOfTransport?.slice(1).toLocaleLowerCase();
    const best_fit = selectedOrder?.transportOptions?.selectedOption && selectedOrder?.transportOptions?.selectedOption === selectedOrder?.recommend_vehicle // added by Bearer Web Developer
    const reservedOrder = appState?.selectedOrder?.selectedReservedOrder;  // added by Bearer Web Developer
    // added by Bearer Web Developer end
    // modified by Bearer Web Developer start
    return (
        <div className={styles.root} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <div className={styles.header}>
                <div className={styles.transport}>Mode of Transport</div>

            </div>
            {
                selectedOrder.transportOptions.selectedOption &&
                <div className={`${styles.transport_description} ${reservedOrder ? styles.reserved_order : ''}`}> {/* reserved_order class added by Bearer Web Developer */}
                    <div>
                        <TransportTypeImage type={selectedOrder.transportOptions.selectedOption} orange={true} />  {/* orange property added by Bearer Web Developer */}
                        <div className={styles.type}>
                            <h3 className={''}>{capitalizeFirstLetterMadeOfTransport}</h3>
                            {/* added by Bearer Web Developer start - for best_fit */}
                            {best_fit &&
                                (
                                    theme === "dark" ?
                                        <img src="/best-fit-orange.svg" alt="" width={46} height={12} /> :
                                        <img src="/best-fit.svg" alt="" width={46} height={12} />
                                )
                            }
                            {/* added by Bearer Web Developer end - for best_fit */}
                        </div>
                    </div>
                    {/* added by Bearer Web Developer start */}
                    <div>
                        <h4 className={''}>{order?.selectedTransportOption?.time}</h4>
                        {showRealPrice && <h5 className={''}>${realPrice}</h5>}
                    </div>
                    {/* added by Bearer Web Developer end */}
                </div>
            }
            {
                !isDisabled && !reservedOrder && // reservedOrder added by Bearer Web Developer
                <div className={styles.edit_part}>
                    <Button variant="text" onClick={() => {
                        if (order?.autoSelectTransport) order?.setAutoSelectTransport(false); // added by Bearer Web Developer
                        transport.setEditing(true)
                    }}>
                       {
                        theme === "dark" ?  <img src="/expand_more_black.png" alt="" width={24} height={24} /> :
                         <img src="/expand-address.png" alt="" width={24} height={24} />
                       }
                    </Button>
                </div>
            }
        </div>
    );
    // modified by Bearer Web Developer end
})
export default TransportsCompact;


